import {isEmpty, isNil, keys} from 'ramda';

import {Nullish} from 'shared/web';

import {DrillDownLevel, DrillDownLevelName} from '../../../../../types/api/drillDown';

export function getPermanentLevelFilters(
  permanentFilters: Partial<Record<DrillDownLevelName, string>> | Nullish
): DrillDownLevel[] {
  if (isNil(permanentFilters) || isEmpty(permanentFilters)) {
    return [];
  }

  return keys(permanentFilters).map((levelName, index) => ({
    level: levelName,
    values: [permanentFilters[levelName] ?? ''],
    priority: index + 1,
  }));
}
